import * as React from 'react';
import { childClassClosure, ClassableProps, baseClassAnd } from "@jcharlesworthuk/your-mum-core/dist/functions";
import './NiceTextField.scss';
import { InputChangeDelegate } from '../../helpers/InputDelegates';

const baseClass = 'nice-text-field';
const childClass = childClassClosure(baseClass);


type Props = ClassableProps & {
    label: string;
    fullWidth?: boolean;
    value: string;
    error?: boolean;
    onChange: InputChangeDelegate;
    disabled?: boolean;
    isOptional?: boolean;
    placeholder?: string;
    type?: 'text' | 'password' | 'email' | undefined;
}

/**
 * This is intended to look nice and capture the user's attention, for things like signup forms.
 * Use Material UI type inputs for efficient input, and these for when you want it to be part of a UX journey.
 */
const NiceTextField: React.FunctionComponent<Props> = props => {
    const fieldName = props.label.replace(' ', '');
    const validationClass = props.error === true && props.isOptional != true ? 'invalid' : '';
    
  return <div className={baseClassAnd(baseClass, props)}>
    <label htmlFor={fieldName}>{props.label} {props.isOptional == true ? <small>(optional)</small> : ''}</label>
    <div className={childClass('control-wrapper', validationClass)}>
      <input type={props.type || 'text'}
        className={childClass('input', validationClass)}
        name={fieldName}
        value={props.value}
        onChange={props.onChange}
        required={!props.isOptional}
        disabled={!!props.disabled}
        placeholder={props.placeholder} />
    </div>
  </div>
}

export default NiceTextField;